import { render } from "./CoreForm.vue?vue&type=template&id=1378eaa8"
import script from "./CoreForm.vue?vue&type=script&lang=js"
export * from "./CoreForm.vue?vue&type=script&lang=js"
script.render = render

export default script